export enum EntityStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}
